import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../helpers';
import { Device, DeviceService, Group, GroupService } from '../../shared';

@Component({
  selector: 'open-dialog',
  templateUrl: 'open-dialog.component.html',
})
export class OpenDialog {
  public groups: Group[] = [];
  public groupArray: Group[] = [];
  public groupId: string;
  public group: number;
  public checkedDevices;

  constructor(
    private _groupService: GroupService,
    private _toastr: ToastrService,
    public dialogRef: MatDialogRef<OpenDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.groups = data.groups;
    this.groupArray = data.groupArray;
    this.groupId = data.groupId;
    this.group = data.group;
    this.checkedDevices = data.checkedDevices;
  }

  public getAllGroups(event) {
    Helpers.setLoading(true);
    this._groupService.getAll().subscribe((groups) => {
      Helpers.setLoading(false);
      this.groups = groups.sort(function (a, b) {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      });
    });
  }

  public addDeviceToGroup(event) {
    const deviceId = this.checkedDevices;
    deviceId.forEach((id) => {
      this._groupService.addDeviceToGroup(this.groupId, id).subscribe(
        (data) => {
          this._toastr.success('Devices assigned successfully');
          Helpers.setLoading(false);
        },
        (error) => {
          this.handleError(error, 'Error assigning devices');
          Helpers.setLoading(false);
        },
      );
    });

    this.dialogRef.close();
  }

  public handleError(error: any, title: string) {
    try {
      error = JSON.parse(error._body);
      if (error.errorMessage && error.messageDev) {
        this._toastr.error(
          error.errorMessage + '<br>' + error.messageDev,
          title,
        );
      } else if (error.errorMessage && !error.messageDev) {
        this._toastr.error(error.errorMessage, title);
      } else { this._toastr.error(title); }
    } catch (e) {
      this._toastr.error(title);
    }
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
